import * as React from "react";
import { styled } from "@mui/material/styles";
import {
  Table, TableBody, TableContainer, TableHead, TableRow, Paper, Container, IconButton
} from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { Download, Link as LinkIcon } from "@mui/icons-material";

import { useState, useEffect } from "react";

import Config from "../config.json"; // Pastikan file ini ada
import { dateToStringDate } from "../Helpers"; // Pastikan fungsi ini ada

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function Devimaps() {
  // State untuk bagian Events
  const url_list = Config.api_domain + "/devimaps/active/";
  const [list, setList] = useState([]);
  const [search, setSearch] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(5);
  const [page, setPage] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(url_list, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
        if (!res.ok) throw new Error("Server error");

        const data = await res.json();
        setList(data.data || []);
      } catch (error) {
        console.error("Fetch error:", error.message);
      }
    };

    fetchData();
  }, [url_list]);

  const filteredList = list.filter(item =>
    item.title.toLowerCase().includes(search.toLowerCase())
  );

  const paginatedList = filteredList.slice(
    page * entriesPerPage,
    (page + 1) * entriesPerPage
  );

  function getRows() {
    if (typeof list !== "undefined" && list !== null && list.length > 0) {
      return list.map((row, index) => {
        let dateISO = new Date(row.time_uploaded);
        let formatted_datetime = dateToStringDate(dateISO);
        return (
          <StyledTableRow key={row.public_id}>
            <StyledTableCell>{index + 1}</StyledTableCell>
            <StyledTableCell>{row.title}</StyledTableCell>
            <StyledTableCell>{formatted_datetime}</StyledTableCell>
            <StyledTableCell>
              <IconButton
                aria-label="download"
                component="a"
                href={Config.api_domain + "/devimaps/download/" + row.public_id}
                download
              >
                <Download />
              </IconButton>
            </StyledTableCell>
          </StyledTableRow>
        );
      });
    } else {
      return (
        <StyledTableRow key="no-data">
          <StyledTableCell colSpan={4} align="center">
            No Data Found
          </StyledTableCell>
        </StyledTableRow>
      );
    }
  }

  return (
    <div style={{ padding: "1em 2em 3em 2em" }}>
      <Container>

        <h2>Development of Integrated Maps</h2>

        <h3>Project Description</h3>
        <p style={{ textAlign: "justify" }}>
          The Integrated Land Administration and Spatial Planning (ILASP) activity supports the Indonesian government in addressing climate change by strengthening spatial planning and improving land tenure security, both of which are critical to reducing carbon emissions and implementing climate change adaptation. This activity will support the provision of high-resolution geospatial data and information that provides the basis for developing climate-based spatial plans that steer agriculture and new infrastructure away from sensitive, high-carbon ecosystems and guide urban densification to reduce encroachment and to build resilient cities. <br></br><br></br>

BIG supports these efforts by carrying out the tasks mandated by regulations, which include producing the Indonesian Base Map (Rupabumi Map/ RBI) at scales of 1:1,000, 1:5,000, 1:25,000, 1:50,000, 1:250,000, and 1:1,000,000. The Provision of the RBI map is carried out in stages and systematically for the entire territory of the Republic of Indonesia. The acceleration of the provision of large-scale base maps is the most important part of provisioning basic geospatial data and information throughout Indonesia. In accordance with Government Regulation Number 45 of 2021 concerning the administration of Geospatial Information (IG), it consists of a series of activities, namely the collection of Geospatial Data and Information (DG/IG), processing of DG/IG, storage and security of DG/IG, dissemination of DG/IG, and the use of IG.
<br></br><br></br>
In order to support the provision of accelerated large-scale base maps, it is necessary to develop an integrated cloud-based production system through high-performance geospatial processing and computing to facilitate the provision of basic geospatial information in the national scale production. The utilization of large-scale basic geospatial information can support the realization of national resilience, including serving as a reference for the implementation of action steps as anticipatory measures in facing climate change. With the development of this cloud-based production system, the production of base maps, which includes DG processing activities to form the elements of base maps, will be supported within an advanced production system in line with the progress of science and technology.
<br></br><br></br>The large-scale base map production activities supported by cloud-based technology have advantages such as data being accessible from anywhere and anytime when needed, facilitating the process of data transfer from the field, ensuring the consistency of the generated basic DG and IG, speeding up the IG administration process, and making infrastructure management easier. In addition, the provision of cloud-based infrastructure, in accordance with Presidential Regulation Number 95 year 2018 on the Electronic-Based Government System (SPBE) and the fulfillment of Government Regulation Number 71 year 2019 on the Implementation of Electronic Systems and Transactions related to the obligation to manage, process, and/or store Electronic Systems and Electronic Data within the territory of Indonesia.
<br></br><br></br>Cloud-based map production activities will be facilitated in the development of an integrated map production system at BIG’s Geospatial Computing Center, which refers to the series of processes, methods, and technologies used to generate, manage, and disseminate geospatial data and information. At the geospatial computing center, this integrated map production system focuses on processing spatial data such as maps, satellite images, and other geospatial data by utilizing high-performance computing capabilities to produce products that can be used by various applications.
        </p>

        {/* Unduh Section */}
        <h3>Announcement</h3>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 500 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>No</StyledTableCell>
                <StyledTableCell>Announcement</StyledTableCell>
                <StyledTableCell>Publication Date</StyledTableCell>
                <StyledTableCell>Download</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {getRows()}
            </TableBody>
          </Table>
        </TableContainer>

        <h3>Procurement Timeline</h3>
        <TableContainer component={Paper} sx={{ mb: 6 }}>
  <Table sx={{ minWidth: 800 }} aria-label="timeline table">
    <TableHead>
      <TableRow>
        <StyledTableCell>No.</StyledTableCell>
        <StyledTableCell>Activity</StyledTableCell>
        <StyledTableCell>Start Date</StyledTableCell>
        <StyledTableCell>End Date</StyledTableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      <StyledTableRow>
        <StyledTableCell>1</StyledTableCell>
        <StyledTableCell>Announcement</StyledTableCell>
        <StyledTableCell>08 September 2025, 13:00 (GMT+7)</StyledTableCell>
        <StyledTableCell>19 September 2025, 16:00 (GMT+7) UPDATE</StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>2</StyledTableCell>
        <StyledTableCell>Submission of EOI</StyledTableCell>
        <StyledTableCell>08 September 2025, 13:00 (GMT+7)</StyledTableCell>
        <StyledTableCell>19 September 2025, 16:00 (GMT+7) UPDATE</StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>3</StyledTableCell>
        <StyledTableCell>Shortlist Appointment</StyledTableCell>
        <StyledTableCell>22 September 2025, 00:00 (GMT+7)</StyledTableCell>
        <StyledTableCell>24 September 2025, 23:59 (GMT+7)</StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>4</StyledTableCell>
        <StyledTableCell>Issuance of RFP</StyledTableCell>
        <StyledTableCell>25 September 2025, 00:00 (GMT+7)</StyledTableCell>
        <StyledTableCell>15 October 2025, 12:00 (GMT+7)</StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>5</StyledTableCell>
        <StyledTableCell>Clarification Request Period</StyledTableCell>
        <StyledTableCell>29 September 2025, 10:00 (GMT+7)</StyledTableCell>
        <StyledTableCell>06 October 2025, 09:00 (GMT+7)</StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>6</StyledTableCell>
        <StyledTableCell>Submission of Technical and Financial Proposals</StyledTableCell>
        <StyledTableCell>25 September 2025, 00:00 (GMT+7)</StyledTableCell>
        <StyledTableCell>15 October 2025, 12:00 (GMT+7)</StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>7</StyledTableCell>
        <StyledTableCell>Opening of Proposals</StyledTableCell>
        <StyledTableCell>15 October 2025, 12:01 (GMT+7)</StyledTableCell>
        <StyledTableCell>22 October 2025, 23:59 (GMT+7)</StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>8</StyledTableCell>
        <StyledTableCell>Evaluation of Technical Proposals</StyledTableCell>
        <StyledTableCell>15 October 2025, 12:01 (GMT+7)</StyledTableCell>
        <StyledTableCell>22 October 2025, 23:59 (GMT+7)</StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>9</StyledTableCell>
        <StyledTableCell>Evaluation of Financial Proposals</StyledTableCell>
        <StyledTableCell>23 October 2025, 00:00 (GMT+7)</StyledTableCell>
        <StyledTableCell>23 October 2025, 23:59 (GMT+7)</StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>10</StyledTableCell>
        <StyledTableCell>Notification of Intention of Award</StyledTableCell>
        <StyledTableCell>24 October 2025, 00:00 (GMT+7)</StyledTableCell>
        <StyledTableCell>24 October 2025, 23:59 (GMT+7)</StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>11</StyledTableCell>
        <StyledTableCell>Standstill Period</StyledTableCell>
        <StyledTableCell>27 October 2025, 00:00 (GMT+7)</StyledTableCell>
        <StyledTableCell>07 November 2025, 16:00 (GMT+7)</StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>12</StyledTableCell>
        <StyledTableCell>Contract Negotiation</StyledTableCell>
        <StyledTableCell>07 November 2025, 16:01 (GMT+7)</StyledTableCell>
        <StyledTableCell>11 November 2025, 23:59 (GMT+7)</StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>13</StyledTableCell>
        <StyledTableCell>Notification of Award</StyledTableCell>
        <StyledTableCell>12 November 2025, 00:00 (GMT+7)</StyledTableCell>
        <StyledTableCell>12 November 2025, 23:59 (GMT+7)</StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>14</StyledTableCell>
        <StyledTableCell>Contract Signing</StyledTableCell>
        <StyledTableCell>13 November 2025, 00:00 (GMT+7)</StyledTableCell>
        <StyledTableCell>21 November 2025, 23:59 (GMT+7)</StyledTableCell>
      </StyledTableRow>
    </TableBody>
  </Table>
</TableContainer>

<p>The package will be processed through SPSE ICB at the link: <a
    href="mailto: https://spseicb.lkpp.go.id/spseicb/"
    style={{ color: "#1976d2", textDecoration: "underline" }}
  > https://spseicb.lkpp.go.id/spseicb/</a></p> 
      </Container>
    </div>
  );
}

export default Devimaps;
